const config = {
	api: 'https://ust-testing.beautitag.com/summercamp/api',
	appPath: '/summercamp/app',
	loginTimeout: 18000000
};

export default config;